import BaseHeaderMenuComponent from "./base-header-menu/base-header-menu-component";
import SectionsHeaderMenuComponent from "./sections-header-menu/sections-header-menu-component";
import StructuredHeaderMenuComponent from "./structured-header-menu/structured-header-menu-component";
export default {
    BaseHeaderMenuComponent,
    SectionsHeaderMenuComponent,
    StructuredHeaderMenuComponent
};
